module.exports = __webpack_public_path__ + "public/img/Pengelolaan Akuntansi Dan Perpajakan Bagi Akuntan Untuk UMKM.c6e5e0fc.png";